import { connect } from 'react-redux'
import Inbound from './Inbound.component'
import * as Actions from 'state/actions'

const mapStateToProps = state => {
  return {
    chartType: state.analyticsMessages.chartType,
    granularity: state.analyticsMessages.granularity,
    dateRange: state.analyticsMessages.dateRange,
    customDateRange: state.analyticsMessages.customDateRange,
    channelNameToFilter: state.analyticsMessages.channelNameToFilter
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onChangeChartType: chartType => () => dispatch(Actions.messagesChangeField('chartType', chartType)),
    onChangeGranularity: granularity => () => dispatch(Actions.messagesChangeField('granularity', granularity)),
    onMoveCustomDateRange: operation => () => dispatch(Actions.messagesMoveCustomDateRange(operation)),
    onChangeSelectField: field => e => dispatch(Actions.messagesChangeField(field, e.target.value)),
    onChangeCustomDateRange: ({ startDate, endDate }) => dispatch(Actions.messagesChangeDateRange(startDate, endDate))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Inbound)
